/**
 * 人脸识别结果
 */

import { saveOldLocation } from '../../modules/actions';
import { loadStatusCodeMsg } from 'enEXchange';

export default store => ({
  path: 'certificationResults',
  onEnter(nextState, replace, callback) {
    loadStatusCodeMsg(['createRefundTa']);
    callback();
  },
  onLeave(prevState) {
    store.dispatch(saveOldLocation(prevState.location));
  },
  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        const certificationResults = require('./components/certificationResults')
          .default;
        cb(null, certificationResults);
      },
      'certificationResults'
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/routes/certificationResults/index.js